/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.toolhealth.ToolHealthScope
*/
export var ToolHealthScope;
(function (ToolHealthScope) {
    ToolHealthScope["SESSION"] = "SESSION";
    ToolHealthScope["USER"] = "USER";
    ToolHealthScope["PROJECT"] = "PROJECT";
    ToolHealthScope["TENANT"] = "TENANT";
    ToolHealthScope["GLOBAL"] = "GLOBAL";
})(ToolHealthScope || (ToolHealthScope = {}));
//# sourceMappingURL=ToolHealthScope.js.map